import { useEffect } from 'react';

type WistiaVideoProps = {
  autoPlay?: boolean
  className?: string,
  hashedId?: string
}

const WistiaVideo = ({ autoPlay, className, hashedId }:WistiaVideoProps) => {
  useEffect(() => {
    if (!document.getElementById('wistia_script')) {
      const wistiaScript = document.createElement('script');
      wistiaScript.id = 'wistia_script';
      wistiaScript.type = 'text/javascript';
      wistiaScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      wistiaScript.async = true;
      document.body.appendChild(wistiaScript);
    }
  }, []);

  return (
    <div className={ className ?? '' }>
      <div className="wistiaWrapper">
        <div className="wistiaFill">
          <div
            className={ `wistia_embed wistia_async_${hashedId} ${
              autoPlay ? 'autoPlay=true' : ''
            } videoFoam=true wistiaEmbeded` }
          >
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  );
};

export default WistiaVideo;